import { Component } from '@angular/core';

@Component({
  templateUrl: './panels.html'  
})
export class PanelsComponent { 
    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/panels/panels-component.ts